import { render, staticRenderFns } from "./LoadingVehicle.vue?vue&type=template&id=4c5a3dd8&scoped=true&"
import script from "./LoadingVehicle.vue?vue&type=script&lang=js&"
export * from "./LoadingVehicle.vue?vue&type=script&lang=js&"
import style0 from "./LoadingVehicle.vue?vue&type=style&index=0&id=4c5a3dd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a3dd8",
  null
  
)

export default component.exports